import { Link } from "react-router-dom";
import { Logo, Wordmark } from "./Logo";

export default function Footer() {
  return (
    <footer className="bg-[#050505] border-t border-white/10" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <Logo />
              <Wordmark />
            </div>
            <p className="text-white/45 mt-6 max-w-sm font-light">
              Creating spectacular experiences through light, sound &amp; vision. Event solutions that inspire generations.
            </p>
          </div>
          <div className="md:col-span-3">
            <div className="text-white/40 text-xs tracking-widest mb-4">EXPLORE</div>
            <ul className="space-y-3 text-white/65">
              {["services", "process", "work", "quote"].map((id) => (
                <li key={id}>
                  <button
                    onClick={() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" })}
                    className="hover:text-[#F5B841] transition-colors capitalize"
                  >
                    {id === "quote" ? "Request a Quote" : id}
                  </button>
                </li>
              ))}
              <li>
                <a
                  data-testid="footer-brochure"
                  href="/bhaaskar-brochure.pdf"
                  download="Bhaaskar-Productions-Brochure.pdf"
                  className="hover:text-[#F5B841] transition-colors"
                >
                  Download Brochure
                </a>
              </li>
            </ul>
          </div>
          <div className="md:col-span-4">
            <div className="text-white/40 text-xs tracking-widest mb-4">CONTACT</div>
            <ul className="space-y-3 text-white/65">
              <li><a href="tel:9866633016" className="hover:text-[#F5B841] transition-colors">+91 98666 33016</a></li>
              <li><a href="mailto:bhaaskarproductions@gmail.com" className="hover:text-[#F5B841] transition-colors">bhaaskarproductions@gmail.com</a></li>
              <li><a href="https://www.bhaaskarproductions.com" target="_blank" rel="noopener noreferrer" data-testid="footer-website" className="hover:text-[#F5B841] transition-colors">www.bhaaskarproductions.com</a></li>
              <li className="text-white/40">Hyderabad, Telangana, India</li>
            </ul>
          </div>
        </div>
        <div className="border-t border-white/10 mt-14 pt-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <span className="text-white/35 text-sm">© {new Date().getFullYear()} Bhaaskar Productions. All rights reserved.</span>
          <Link to="/admin/login" data-testid="footer-admin-link" className="text-white/25 text-xs hover:text-[#F5B841] transition-colors">
            Admin
          </Link>
        </div>
      </div>
    </footer>
  );
}
